//
// helper
//

import { LOCAL_STRAGE_KEY } from './Settings'
import * as MyAPI from './MyAPI'

import { phonetic_char_list } from './phonetic_char_list'


export const validateEmail = (email) => {
  let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const validURL = (str) => {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str);
}

export const validatePassword = (str) => {
  if (str.length < 6) {
    return("too_short");
  } else if (str.length > 50) {
    return("too_long");
  } else if (str.search(/\d/) === -1) {
    return("no_num");
  } else if (str.search(/[a-zA-Z]/) === -1) {
    return("no_letter");
  }
  return
}

export const loginWithToken = async (login_token) => {

  if (login_token) {
    let _rtnObj = await _call_loginWithTokenAPI(login_token)
    if (_rtnObj.status === true) {
      return {
        status: true,
        token_params: _rtnObj.token_params
      }
    } else {
      return {
        status: false,
      }
    }
  }

  // check if brower have login token
  let storage_data = localStorage.getItem(LOCAL_STRAGE_KEY)
  if (!storage_data) {
    return {
      status: false
    }
  }
  let login_token_storage = JSON.parse(storage_data)
  if (login_token_storage) {
    let _rtnObj = await _call_loginWithTokenAPI(login_token_storage)
    return {
      status: _rtnObj.status,
      token_params: _rtnObj.token_params
    }
  } else {
    return {
      status: false
    }
  }
}

// login with token
const _call_loginWithTokenAPI = async (login_token) => {

  try {

    // sign in with password
    let _results = await MyAPI.signinWithToken({
      login_token: login_token,
    })

    if (_results.status !== 'success') {

      return {
        status: false,
      }
    }

    // success
    let token_params = {
      user_info: _results.user_info,
      login_token: _results.login_token,
      createdAt: new Date(),
    }

    return {
      status: true,
      token_params: token_params,
    }

  } catch (err) {
    console.log("err: ", err)
    return {
      status: false,
      message: err.message,
    }
  }
}

export const makeid = (length) => {
   var result           = '';
   var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
   var charactersLength = characters.length;
   for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
}


// create start times list for blocks data
export const _createStartTimes = ( blocks, editor_width, start_index ) => {

  if (!start_index) {
    start_index = 0
  }

  // let chunk_duration = 0
  let _start_times = []

  for ( let i=0; i<blocks.length; i++ ) {

    let _block = blocks[i]
    let _key = _block.key
    let _text = _block.text

    let _time0 = ""
    if (_block.data && _block.data.time0 ){
      _time0 = _block.data.time0
    }

    // start and end time
    let start_time = -1
    if (_block.data && _block.data.start_time ){
      start_time = _block.data.start_time
    }
    // start and end time
    let end_time = -1
    if (_block.data && _block.data.end_time ){
      end_time = _block.data.end_time
    }

    if (start_time !== -1 && end_time !== -1) {

      // let _str0 = _time0.split("___")[0]
      // let _str1 = _str0.split("@")[0]
      let _start = parseFloat(parseFloat(start_time).toFixed(2))
      let _end = parseFloat(parseFloat(end_time).toFixed(2))
      let _duration = _end - _start
      _duration = parseFloat(parseFloat(_duration).toFixed(2))

      _start_times.push({
        index: i+start_index,
        type: "text",
        key: _key,
        start: _start,
        end: _end,
        duration: _duration,
      })

      // calculate width
      let _span = document.createElement('span');
      // _span.setAttribute("style", "font-size: 1rem; font-weight: 400;");
      _span.setAttribute("style", "font-size: 18px;");
      _span.innerText = _text
      document.body.appendChild(_span);
      let _span_w = _span.getBoundingClientRect().width
      let _span_h = _span.getBoundingClientRect().height
      document.body.removeChild(_span);

      // console.log("")
      // console.log("_text: ", _text)
      // console.log("_span_w: ", _span_w)
      // console.log("_span_h: ", _span_h)
      // console.log("editor_width: ", editor_width)
      // console.log("")

      // -6 is hard coded.
      let line_count = Math.ceil(_span_w / (editor_width-6) )

      if (line_count > 1) {
        for (let j=0; j<line_count-1; j++) {

          _start_times.push({
            index: i+start_index,
            type: "multi_line",
            key: _key+j,
            start: "",
            end: "",
            duration: "",
          })
        }
      }

    } else {
      _start_times.push({
        index: i+start_index,
        type: "unknown",
        key: _key,
        start: "",
        end: "",
        duration: "",
      })
    }
  }

  // get dration between...
  let last_end = 0
  for (let i=0; i<_start_times.length; i++) {
    let item = _start_times[i]

    if (item.type !== "text") {
      continue
    }

    if (item.start !== 0 && !item.start) {
      continue
    }
    let duration2 = item.start - last_end

    _start_times[i]['time_for_next'] = parseFloat(duration2).toFixed(2)
    last_end = item.end
  }

  return _start_times
}



// create start times list for blocks data
export const _createStartTimesFromTime0 = ( blocks, editor_width ) => {

  // let chunk_duration = 0
  let _start_times = []

  for ( let i=0; i<blocks.length; i++ ) {

    let _block = blocks[i]
    let _key = _block.key
    let _text = _block.text

    let _time0 = ""
    if (_block.data && _block.data.time0 ){
      _time0 = _block.data.time0
    }

    if (_time0) {

      let _str0 = _time0.split("___")[0]
      let _str1 = _str0.split("@")[0]
      let _start = parseFloat(parseFloat(_str1.split("~")[0]).toFixed(2))
      let _end = parseFloat(parseFloat(_str1.split("~")[1]).toFixed(2))
      let _duration = _end - _start
      _duration = parseFloat(parseFloat(_duration).toFixed(2))

      if (_str1 !== "dummy") {

        _start_times.push({
          index: i,
          type: "text",
          key: _key,
          start: _start,
          end: _end,
          duration: _duration,
        })

      } else {

        _start_times.push({
          index: i,
          type: "dummy",
          key: _key,
          start: "",
          end: "",
          duration: "",
        })

      }

      // calculate width
      let _span = document.createElement('span');
      _span.setAttribute("style", "font-size: 1rem;");
      _span.innerText = _text
      document.body.appendChild(_span);
      let _span_w = _span.getBoundingClientRect().width
      document.body.removeChild(_span);

      let line_count = Math.ceil(_span_w / (editor_width-6) )

      if (line_count > 1) {
        for (let j=0; j<line_count-1; j++) {

          _start_times.push({
            index: i,
            type: "multi_line",
            key: _key+j,
            start: "",
            end: "",
            duration: "",
          })
        }
      }

    } else {
      _start_times.push({
        index: i,
        type: "unknown",
        key: _key,
        start: "",
        end: "",
        duration: "",
      })
    }
  }

  // get dration between...
  let last_end = 0
  for (let i=0; i<_start_times.length; i++) {
    let item = _start_times[i]

    if (item.type !== "text") {
      continue
    }

    if (item.start !== 0 && !item.start) {
      continue
    }
    let duration2 = item.start - last_end
    // console.log(item.type, " duration2: ", duration2)
    _start_times[i]['time_for_next'] = parseFloat(duration2).toFixed(2)
    last_end = item.end
  }

  // setStartTimes(_start_times)

  return _start_times
}

// check if kana exists
export const _check_if_hiragana_only = (data_str) => {

  let hiraganaonly = true
  for (let i=0; i<data_str.length; i++){
    const word1 = data_str[i]
    if ( phonetic_char_list.indexOf(word1) === -1) {
      hiraganaonly = false
      break
    }
  }

  return hiraganaonly
}


// 正解: 予測
export const expand_list_default = {
  "いい": ["良い"],
  "おっしゃっ": ["仰っ"],
  "いう": ["言う"],
  "やつ": ["奴"],
  "かける": ["掛ける"],
  "カタチ": ["形"],
  "いたし": ["致し"],
  "頂く": ["いただく"],
  "頂い": ["いただい"],
  "是非": ["ぜひ"],
  "事": ["こと"],
  "カスタマー": ["カスタマ"],
  "ゼロ": ["0"],
  "キューアンドエー": ["QアンドA", "Q&A"],
  "私": ["わたくし"],
  "宛て": ["宛"],
  "頂け": ["いただけ"],
  "FAX": ["ファックス"],
  "Web": ["ウェブ"],
  ".com": ["ドットコム"],
  "はじめ": ["初め"],
  "マネジメント": ["マネージメント"],
  "良い": ["いい"],
  "仰っ": ["おっしゃっ"],
  "言う": ["いう"],
  "奴": ["やつ"],
  "掛ける": ["かける"],
  "形": ["カタチ"],
  "致し": ["いたし"],
  "いただく": ["頂く"],
  "ぜひ": ["是非"],
  "こと": ["事"],
  "カスタマ": ["カスタマー"],
  "QアンドA": ["キューアンドエー", "Q&A"],
  "Q&A": ["キューアンドエー", "QアンドA"],
  "わたくし": ["私"],
  "宛": ["宛て"],
  "いただけ": ["頂け"],
  "ファックス": ["FAX"],
  "ウェブ": ["ウェブ"],
  "ドットコム": [".com"],
  "初め": ["はじめ"],
  "マネージメント": ["マネジメント"],
  "引き継ぎ": ["引継ぎ", "引継"],
  "引継ぎ": ["引き継ぎ", "引継"],
  "引継": ["引き継ぎ", "引継ぎ"],
  "切替": ["切り替え"],
  "切り替え": ["切替"],
  "Mpa": ["メガパスカル"],
  "メガパスカル": ["Mpa"],
  "Mpa": ["メガパスカル"],
  "L": ["リットル", "リッター"],
  "リットル": ["L"],
  "リッター": ["L"],
  "/": ["パー", "per", "／"],
  "／": ["パー", "per", "/"],
  "パー": ["/", "per", "／"],
  "min": ["ミニッツ", "minutes"],
  "ミニッツ": ["min", "minutes"],
  "minutes": ["ミニッツ","minutes"],
  "アンペア": ["A"],
  "A": ["アンペア"],
  "-": ["ハイホン", "ハイフン"],
  "ハイホン": ["-", "ハイフン"],
  "ハイフン": ["-", "ハイホン"],
  "様": ["よう"],
  "よう": ["様"],
}
